import { Fragment } from 'react'
import { connectResources, ResourceType } from '@ds-frontend/resource'
import PropTypes from 'prop-types'
import { compose } from 'redux'

import Footer from './FooterQuoteView'
import { mockQuoteFooter } from './mock'
import QuotePrint from 'components/quote/widgets/HeaderQuote/QuotePrint'
import withInfoHOC from 'hocs/withInfoHOC'
import classNames from './layout.module.scss'


QuoteLayout.propTypes = {
  children: PropTypes.node,
  quoteList: ResourceType.isRequired,
  cmsInfo: ResourceType.isRequired,
}

function QuoteLayout({ children = null, quoteList }) {
  return (
    <Fragment>
      <div className={classNames.layout}>
        <div className={classNames.screenOnly}>
          {children}
        </div>
        <QuotePrint />
        <Footer footerData={{ data: mockQuoteFooter }} />
      </div>
    </Fragment>
  )
}

export default compose(
  connectResources('quoteList'),
  withInfoHOC,
)(QuoteLayout)
